import { Injectable } from '@angular/core';
import { Http } from '@angular/http';

import { Client } from '../models/client';
import { Api } from './api';

@Injectable()
export class Clients {
  clients: Client[];
  client: Client;
  schedules = [];

  defaultItem: any = {
      "id": "84748",
      "user_id": "6324",
      "first_name": "Generic",
      "last_name": "Client",
      "sex_id": "3",
      "date_of_birth": "1800-01-01",
      "active": "1",
  };


  constructor(public http: Http, public api: Api) {
    
  }

  getClientList(params?: any){
    if (params) {
      var seq =  this.api.getClients('clients/withgroup?' + params);
    } else {
      var seq =  this.api.getClients('clients/withgroup');
    }
    seq
    .subscribe(res => {
      this.clients = res;
  },
      err => {
          console.log(err);
      });
    return seq;
  }

  getClientSmallList(params?: any){
    if (params) {
      var seq =  this.api.getClients('clients?keyword=' + params);
    } else {
      var seq =  this.api.getClients('clients');
    }
    seq
    .subscribe(res => {
      this.clients = res;
  },
      err => {
          console.log(err);
      });
    return seq;
  }

  getClients(params?: any) {
      if (!params) {
          return this.clients;
      }
      return this.clients.filter((item) => {
              return (item.first_name.toLowerCase().indexOf(params.toLowerCase()) > -1 || item.last_name.toLowerCase().indexOf(params.toLowerCase()) > -1 || item.first_name.concat(' ').concat(item.last_name).toLowerCase().indexOf(params.toLowerCase()) > -1);
       }
      )
      
  }

  addClient(client: Client) {
      let seq =  this.api.addClient('clients', client).share();
        seq
        .map(res => res.json().data.client)
        .subscribe(res => {
          // If the API returned a successful response, push the response in the clientsList
          this.clients.push(res);
        }, err => {
          console.error('ERROR', err);
        });

      return seq;
    
  }

  addClientStatic(client: Client) {
    console.log('aaa');
      let seq =  this.api.addClient('clients', client).share();
        seq
        .map(res => res.json().data.client)
        .subscribe(res => {
          // If the API returned a successful response, push the response in the clientsList
        }, err => {
          console.error('ERROR', err);
        });

      return seq;
    
  }

  editClient(client: Client, id: string) {
    return this.api.editClient('clients', client, id)
  
}

  deleteClient(item: Client, id: string) {
    //this.clients.splice(this.clients.indexOf(item), 1);
    this.clients.splice(this.clients.findIndex(i => i.id === item.id),1);
    return this.api.deleteClient('clients', item, id);
  }

  deleteClientStatic(item: Client, id: string) {
    return this.api.deleteClient('clients', item, id);
  }

  clientChangeStatus(id, status) {
    return this.api.clientChangeStatus('clients/change_status', id, status)
  }

  setClientGrouping(ids, group_id, add) {
    return this.api.setClientGrouping('clients/toggle_grouping', ids, group_id, add)
  }

  addNote(note){
    return this.api.addNote('clients', note);

  }

  editNote(note){
    return this.api.updateNote('notes', note);

  }

  deleteNote(id){
    return this.api.deleteNote('notes', id);

  }

  // getSchedules(params?: any){
  //   return this.api.getSchedules('schedules');
  // }

  getGroupings(params?: any){
    let seq =  this.api.getGroupings('groupings');
    seq
    .map(res => res)
    .subscribe(res => {
    }, err => {
      console.error('ERROR', err);
    });

  return seq;
  }

  getSchedules(params?: any){
    let seq =  this.api.getSchedules('schedules');
    seq
    .map(res => res)
    .subscribe(res => {
    }, err => {
      console.error('ERROR', err);
    });

  return seq;
  }


}



// WEBPACK FOOTER //
// ./src/providers/clients.ts